import React,
{ Component } from 'react'
import { connect } from 'react-redux'

import { Button } from '@driftt/dds'
import {
  Footer,
  Input,
  P,
  Section,
  Sidebar
} from '@driftt/tide-core'
import { createNewContact } from 'api/contacts'

import './style.css'

const mapStateToProps = state => ({ orgId: state.user.orgId })

class CreateNewContactSidebar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      saving: false,
      firstName: '',
      lastName: '',
      email: ''
    }
  }

  saveContact = () => {
    this.setState({ saving: true }, this.sendContact)
  }

  sendContact = async () => {
    const { orgId } = this.props
    const {
      firstName,
      lastName,
      email
    } = this.state

    const contact = {
      attributes: {
        first_name: firstName,
        last_name: lastName
      },
      email,
      name: `${firstName} ${lastName}`
    }

    try {
      await createNewContact(contact, orgId)

      this.setState({ saving: false }, this.props.close)
    } catch(e) {
      console.log(e)
    }
  }

  render() {
    const {
      open,
      close
    } = this.props

    const {
      saving,
      firstName,
      lastName,
      email
    } = this.state

    const hasAllFields = (firstName && lastName && email)

    return (
      <Sidebar
        isOpen={open}
        showClose={true}
        hideOverlay={true}
        className="contacts-new-contact-sidebar"
        close={close}
        title={'Create new contact'}
      >
        <Section>
          <Input type="email" label="Email address"
            placeholder="Enter email address…" onChange={(event) => this.setState({ email: event.target.value })}/>
          <Input type="text" label="First name"
            placeholder="Enter first name…" onChange={(event) => this.setState({ firstName: event.target.value })}/>
          <Input type="text" label="Last name"
            placeholder="Enter last name…" onChange={(event) => this.setState({ lastName: event.target.value })}/>
          <P>
            Drift respects privacy rights and data protection laws. You may only share other people's personal information with Drift, whether directly or through third-party integrations, if you are permitted to do so under applicable law. 
            <a href="https://www.drift.com/privacy-policy/" rel="noopener noreferrer"
              target="_blank">View our Privacy Policy
            </a>.
          </P>
        </Section>
        <Footer>
          <Button onClick={this.saveContact}
            disabled={saving || !hasAllFields}>Save contact
          </Button>
        </Footer>
      </Sidebar>
    )
  }
}

export default connect(mapStateToProps, null)(CreateNewContactSidebar)
